/** Used to match template delimiters. */
var reInterpolate = /<%=([\s\S]+?)%>/g;

export default reInterpolate;



//////////////////
// WEBPACK FOOTER
// ./node_modules/lodash-es/_reInterpolate.js
// module id = 803
// module chunks = 0